module.exports = __webpack_public_path__ + "img/delete_account_icon.176f30c6.svg";